<template>
  <div class="safieStyle" style="width: 100%; position: absolute; height: auto !important;">
    <div class="image-container">
      <img src="../assets/img/safieImage.png" alt="Safie Image">
    </div>
  </div>
</template>

<script>
import { setSafieToken } from "@/utils/auth";
import {mapActions} from 'vuex'
export default {
  name: 'SafiePage',
  mounted() {
    this.handleCallback();
  },
  methods: {
    ...mapActions("dashboard", {
      createAccessTokenSafie: "createAccessTokenSafie"
    }),
    handleCallback() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (code) {
        this.getAccessToken(code);
      } else {
        console.error('No verification code.');
      }
    },
    async getAccessToken(code) {
      const clientId = '5cf4b5083d05';
      const clientSecret = 'f43da852fd130dad8b8f022d3f466b0e';
      const redirectUri = process.env.VUE_APP_SAFIE_PAGE;

      var accessTokenSafie = {
        clientId: clientId,
        clientSecret: clientSecret,
        redirectUri: redirectUri,
        code: code
      }
      this.createAccessTokenSafie(accessTokenSafie)
        .then(response => {
          if (response.code === 0) {
            setSafieToken(response.data.access_token)
            if (window.opener) {
              window.opener.postMessage({ loggedIn: true }, "*");
              window.close(); // Optional, to close the login/admin window
            }
          } else {
            console.log("response saffieeee ", response);
          }
        })
        .catch(err => {
          console.log(err);
          if(err.code != undefined)
            this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
        })
        .finally(final => {
          this.isSubmitAction = false;
        });
    },
  },
};

</script>
<style lang="scss" scoped>
.safieStyle {
  width: 100%;
  position: absolute;
  height: auto !important;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 100px;
}

.image-container {
  max-width: 70%;
}

.image-container img {
  width: 100%;
  height: auto;
}
</style>
